import { Routes, Route, NavLink, Navigate, useSearchParams } from 'react-router-dom';
import { TopNav } from '@/components/layout/TopNav';
import { cn } from '@/lib/utils';
import { SettingsGeneral } from '@/components/settings/SettingsGeneral';
import { SettingsBrandKit } from '@/components/settings/SettingsBrandKit';
import { SettingsSocialAccounts } from '@/components/settings/SettingsSocialAccounts';
import { SettingsTrends } from '@/components/settings/SettingsTrends';
import { SettingsAI } from '@/components/settings/SettingsAI';
import { SettingsCanva } from '@/components/settings/SettingsCanva';
import { SettingsMembers } from '@/components/settings/SettingsMembers';

const TABS = [
  { to: '/settings', label: 'General', end: true },
  { to: '/settings/brand-kit', label: 'Brand Kit' },
  { to: '/settings/social-accounts', label: 'Social Accounts' },
  { to: '/settings/trends', label: 'Trends' },
  { to: '/settings/ai', label: 'AI Settings' },
  { to: '/settings/canva', label: 'Canva' },
  { to: '/settings/members', label: 'Members' },
];

export function Settings() {
  // Settings is path-routed; older notification/brief links used ?tab=<section>.
  const [searchParams] = useSearchParams();
  const legacyTab = searchParams.get('tab');
  if (legacyTab && TABS.some((t) => t.to === `/settings/${legacyTab}`)) {
    return <Navigate to={`/settings/${legacyTab}`} replace />;
  }

  return (
    <div className="flex-1 overflow-hidden flex flex-col">
      <TopNav title="Settings" />

      <div className="flex flex-col md:flex-row flex-1 overflow-hidden">
        {/* Settings sidebar */}
        <div className="w-full md:w-48 border-b md:border-b-0 md:border-r border-border py-2 md:py-4 px-2 shrink-0 overflow-x-auto">
          <nav className="flex md:block gap-1 md:space-y-0.5">
            {TABS.map((tab) => (
              <NavLink
                key={tab.to}
                to={tab.to}
                end={tab.end}
                className={({ isActive }) =>
                  cn(
                    'block shrink-0 whitespace-nowrap px-3 py-2 rounded-md text-xs font-medium transition-colors',
                    isActive
                      ? 'bg-accent/10 text-accent'
                      : 'text-muted-foreground hover:text-foreground hover:bg-muted/40'
                  )
                }
              >
                {tab.label}
              </NavLink>
            ))}
          </nav>
        </div>

        {/* Settings content */}
        <div className="flex-1 min-h-0 overflow-y-auto p-4 md:p-6">
          <Routes>
            <Route index element={<SettingsGeneral />} />
            <Route path="brand-kit" element={<SettingsBrandKit />} />
            <Route path="social-accounts" element={<SettingsSocialAccounts />} />
            <Route path="trends" element={<SettingsTrends />} />
            <Route path="ai" element={<SettingsAI />} />
            <Route path="canva" element={<SettingsCanva />} />
            <Route path="members" element={<SettingsMembers />} />
          </Routes>
        </div>
      </div>
    </div>
  );
}
